import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var tableContainer = function tableContainer(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100),
    borderRadius: 0,
    padding: '1.15em',
    overflowX: 'auto',
    '@media (max-width: 767px)': {
      padding: '0.6em'
    }
  };
};
export var filterBarContainer = function filterBarContainer(theme) {
  return {
    position: 'relative',
    borderBottom: "1px solid ".concat(theme.gray100)
  };
};
export var tableHead = function tableHead(theme) {
  return {
    display: 'flex',
    flexFlow: 'row nowrap',
    padding: '0 1.5em',
    backgroundColor: theme.gray50,
    '@media (max-width: 767px)': {
      padding: '0 0.5em'
    }
  };
};
export var tableBodyWrap = function tableBodyWrap(theme) {
  return {
    transition: 'background-color .3s ease-in-out',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '&:hover': {
      backgroundColor: theme.gray50
    }
  };
};
export var tableRow = function tableRow(hasOnClick) {
  return function (theme) {
    return [{
      display: 'flex',
      alignItems: 'center',
      color: theme.gray700,
      padding: '0 1.5em',
      '@media (max-width: 767px)': {
        padding: '0 0.5em'
      }
    }, hasOnClick && {
      cursor: 'pointer'
    }];
  };
};
export var tableCell = function tableCell(_ref) {
  var width = _ref.width,
      flex = _ref.flex,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      invisibleBelow = _ref.invisibleBelow;
  return [{
    flex: flex !== null && flex !== void 0 ? flex : width ? "0 0 ".concat(width) : '1 0 60px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '1.5em 0.7em',
    outline: 'none',
    wordBreak: 'break-word'
  }, invisibleBelow && _defineProperty({}, "@media (max-width: ".concat(invisibleBelow, "px)"), {
    display: 'none'
  }), sm && {
    '@media (max-width: 575px)': {
      display: 'none'
    }
  }, md && {
    '@media (max-width: 767px)': {
      display: 'none'
    }
  }, lg && {
    '@media (max-width: 991px)': {
      display: 'none'
    }
  }, xl && {
    '@media (max-width: 1199px)': {
      display: 'none'
    }
  }];
};
export var moreWrap = {
  padding: '0 1.5em 1em 1.5em'
};
export var moreItem = {
  marginBottom: '0.3em'
};
export var tableHeadCell = function tableHeadCell(options) {
  return function (theme) {
    return [].concat(_toConsumableArray(tableCell(options)), [{
      color: theme.gray500,
      padding: '1em 0.7em'
    }, (options === null || options === void 0 ? void 0 : options.sortable) && {
      cursor: 'default',
      '& b': {
        cursor: 'pointer'
      }
    }]);
  };
};
export var tableHeadIcon = function tableHeadIcon(isAsc, isDesc) {
  return {
    fontSize: 18,
    opacity: isAsc || isDesc ? 1 : 0,
    transform: "rotate(".concat(isDesc ? 0 : 180, "deg)"),
    transition: 'transform 300ms'
  };
};
export var tableCellContent = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '& span': {
    display: 'inline'
  }
};
export var tableCellEmpty = function tableCellEmpty(theme) {
  return {
    width: 32,
    height: 4,
    backgroundColor: theme.gray100,
    borderRadius: 0
  };
};
export var paginationContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'nowrap'
};
export var shownResultsIndicator = function shownResultsIndicator(theme) {
  return {
    color: theme.gray200,
    width: 80,
    textAlign: 'center',
    fontSize: 11,
    marginRight: 8
  };
};
export var paginationButton = function paginationButton(disabled, isActive, small) {
  return function (theme) {
    return [{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      userSelect: 'none',
      width: small ? 20 : 28,
      height: small ? 20 : 28,
      margin: '0 0.6em',
      color: theme.gray200,
      border: '1px solid transparent',
      borderRadius: 0,
      '&:hover': {
        color: theme.gray700,
        backgroundColor: theme.gray100
      }
    }, disabled && {
      cursor: 'not-allowed',
      color: theme.gray200,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.gray200
      }
    }, isActive && {
      borderColor: theme.gray700,
      color: theme.gray700,
      '&:hover': {
        color: theme.gray700
      }
    }];
  };
};
export var tableMessageContainer = function tableMessageContainer(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8rem 3rem',
    flexDirection: 'column',
    '& > .table-message-icon': {
      marginBottom: '2.2rem'
    },
    '& > .table-message-title': {
      fontWeight: 500,
      marginBottom: 12
    },
    '& > .table-message-subtitle': {
      color: theme.gray200
    }
  };
};
export var pageSizeDropdown = {
  width: 120
};